export default __webpack_public_path__ + "static/media/port7.a0023fd5.jpeg";